export default __webpack_public_path__ + "static/4-68e7b4935926aac67362d2223d88c156.jpg";